export default {
  title: 'Gepromote producten',
};
